const apiConfig = {
    webApi: "https://sushigoapi.andai.hu/api/",
    hub: "https://sushigoapi.andai.hu/mainhub/",
  };

export default apiConfig;
